var chevronBack = "https://shopfront-cdn.tekoapis.com/static/fe7f8bf76f2b838c.svg";

export { chevronBack as default };
